import React from "react";
import "./generateheader.css";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

function Header({ header, handleResult }) {

  return (
    <div className={header.length > 14 ? 'mainsoftware__headerh4' : "mainsoftware__header"}>
      <div
        onClick={(e) => {
          e.preventDefault();
          handleResult();
        }}
        className={header.length > 14 ? 'mainsoftware__header__save_exitGreater' : "mainsoftware__header__save_exit"}
      >
        <ArrowBackIosIcon />
        <div className="mainsoftware__header__save_exit__info">
          <h3 >Save & Exit</h3>
          {/* <p>All changes saved at 21:13 pm</p> */}
        </div>
      </div>
      <h4 className={header.length > 14 ? 'mainsoftware__header__headingGreat' : 'mainsoftware__header__heading'}>{header}</h4>
    </div>
  );
}

export default Header;
